import React from 'react'
import PropTypes from 'prop-types'

import FilterButton from './FilterButton'
import SortButton from './SortButton'

function MobileFilter({
  aggregations = {},
  queryParams,
  submitForms,
  ...rest
}) {
  return (
    <div className="d-flex my-4 align-items-center justify-content-between">
      <div>
        <SortButton queryParams={queryParams} submitForms={submitForms} />
      </div>
      <div>
        {Object.keys(aggregations).length > 0 && (
          <FilterButton
            aggregations={aggregations}
            submitForms={submitForms}
            {...rest}
          />
        )}
      </div>
    </div>
  )
}

MobileFilter.propTypes = {
  aggregations: PropTypes.object.isRequired,
  queryParams: PropTypes.object,
  submitForms: PropTypes.func.isRequired,
}

export default MobileFilter
